import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class ThemeManager {
  constructor() {
    this.themeToggle = document.getElementById("themeToggle");
    this.menuThemeToggle = document.querySelector(".menu-theme-toggle");
    this.body = document.body;

    this.init();
  }

  init() {
    // Load saved theme preference
    this.loadTheme();

    // Add click event listener for main theme toggle
    this.themeToggle.addEventListener("click", () => {
      this.toggleTheme();
    });

    // Add click event listener for menu theme toggle
    if (this.menuThemeToggle) {
      this.menuThemeToggle.addEventListener("click", () => {
        this.toggleTheme();
      });
    }
  }

  toggleTheme() {
    const isDarkMode = this.body.classList.contains("dark-mode");

    if (isDarkMode) {
      // Switch to light mode
      this.body.classList.remove("dark-mode");
      localStorage.setItem("theme", "light");
    } else {
      // Switch to dark mode
      this.body.classList.add("dark-mode");
      localStorage.setItem("theme", "dark");
    }

    // Clear any inline styles set by GSAP scroll animations
    const elementsToReset = document.querySelectorAll(
      ".top-line-text, .top-line-text-right, .menu-toggle, .theme-toggle .theme-icon-svg, .top-horizontal-line, .scroll-text, .scroll-line"
    );
    elementsToReset.forEach((element) => {
      if (element) {
        element.style.color = "";
        element.style.backgroundColor = "";
      }
    });

    // Refresh ScrollTrigger to update colors with new theme
    ScrollTrigger.refresh();
  }

  loadTheme() {
    const savedTheme = localStorage.getItem("theme");
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;

    // Use saved theme, or fall back to system preference, or default to light
    const shouldUseDarkMode =
      savedTheme === "dark" || (savedTheme === null && prefersDark);

    if (shouldUseDarkMode) {
      this.body.classList.add("dark-mode");
    } else {
      this.body.classList.remove("dark-mode");
    }
  }
}
